/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

export function objectTypeStateParams(obj: any, type?: any, params?: any): Record<string, any> {
  type = type || obj.objectType || obj.type;

  const stateParams = _.get(type, 'stateParams', {id: obj.id});
  return _.mapValues(stateParams, function(value) {
    if (_.isFunction(value)) {
      value = value(obj, params || {});
    }
    return value && value.charAt && value.charAt(0) === '@' ? _.get(obj, value.substr(1)) : value;
  });
}
